import { createClient } from '@supabase/supabase-js'

const supabaseUrl: any= 'https://blqynsafewnlgcknvfyp.supabase.co'
const supabaseAnonKey: any = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYzMjA3MTk1MSwiZXhwIjoxOTQ3NjQ3OTUxfQ.KApXEJn1_5iY3iTu23P_D8zbJrnG__qrkNHdz8Y-Prk'
// const supabaseServiceKey: any = process.env.REACT_APP_SERVICE_KEY

// export const supabase = createClient(supabaseUrl, supabaseServiceKey);

export const supabase = createClient(supabaseUrl, supabaseAnonKey);


// export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
//     headers: {
//         apiKey: supabaseAnonKey,
//         authorization: `Bearer ${localStorage.getItem("geenwinesaccesstoken")}`
//       }
// })






